import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.scss'

Vue.use(VueAwesomeSwiper)
